import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@afosto/app-components-react/Icon';
import { subtenants as subtenantsApi } from '@afosto/iam/api/Subtenants';
import { useSnackbar } from 'notistack';
import translations from '../../translations';
import useDataSourceContext from '@afosto/app-components-react/DataSource/useDataSourceContext';

const RequestActions = ({ request }) => {
  const intl = useIntl();
  const { reloadDataSource } = useDataSourceContext();
  const { enqueueSnackbar } = useSnackbar();

  const handleRevokeRequest = async () => {
    try {
      await subtenantsApi.updateRequest(request.id, {
        state: 'revoked',
      });

      reloadDataSource();

      enqueueSnackbar(intl.formatMessage(translations.page.feedback.requestRevoked), {
        variant: 'success',
      });
    } catch (err) {
      enqueueSnackbar(intl.formatMessage(translations.page.feedback.requestNotRevoked), {
        variant: 'error',
      });
    }
  };

  return (
    <IconButton onClick={handleRevokeRequest}>
      <Icon icon={['fal', 'ban']} />
    </IconButton>
  );
};

RequestActions.propTypes = {
  request: PropTypes.object,
};

RequestActions.defaultProps = {
  request: {},
};

export default RequestActions;
